module.exports = __webpack_public_path__ + "static/media/SalcoLogoMotion.f7479077.mp4";